import { render, staticRenderFns } from "./discount-categories.vue?vue&type=template&id=91c2815e&scoped=true&"
import script from "./discount-categories.vue?vue&type=script&lang=ts&"
export * from "./discount-categories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c2815e",
  null
  
)

export default component.exports